// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    STRIPE_TEST_PUBLIC_API:
        "pk_test_51JkpNgJjQ0LQyJwshjbEyOwQ2YqSo7j06ZASW97yr66qIyjwvIdoV1fjWBtyEGF9DsW9BkDVIB3dsAO1gXwd9OiD00GdZ7RFTY",
    PHOTON_REALTIME_APP_ID: "93540cb4-198d-45e0-961a-7f44936632b6",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
